import React from 'react';

/**
 * HadenAtlasLogo Component
 * Official HADEN ATLAS branding
 * 
 * Brand Colors:
 * - HADEN: #101957 (dark navy) - Font: Racing Sans One
 * - ATLAS: #C8B59A (gold/tan) - Font: Abril Fatface
 */
const HadenAtlasLogo = ({ 
  size = 'default', 
  showSubtitle = true,
  subtitleText = 'Parts Catalogue',
  variant = 'dark',  // 'dark' for light backgrounds, 'light' for dark backgrounds
  className = ''
}) => {
  // HADEN is 10% larger than ATLAS in each size variant
  // Sizes optimized for header prominence
  const sizes = {
    small: {
      haden: 'text-xl',
      atlas: 'text-lg',
      subtitle: 'text-xs',
      gap: 'gap-0.5'
    },
    default: {
      haden: 'text-[2rem]',     // Reduced by 20% from 2.5rem
      atlas: 'text-[1.8rem]',   // Reduced by 20% from 2.25rem
      subtitle: 'text-xs',
      gap: 'gap-1'
    },
    large: {
      haden: 'text-[2.8rem]',   // Reduced by 20% from 3.5rem
      atlas: 'text-[2.56rem]',  // Reduced by 20% from 3.2rem
      subtitle: 'text-sm',
      gap: 'gap-1'
    },
    xlarge: {
      haden: 'text-[4rem]',     // Reduced by 20% from 5rem
      atlas: 'text-[3.6rem]',   // Reduced by 20% from 4.5rem
      subtitle: 'text-base',
      gap: 'gap-2'
    }
  };

  const s = sizes[size] || sizes.default;
  
  // Variant colors
  const hadenColor = variant === 'light' ? 'text-white' : 'text-[#101957]';
  const atlasColor = 'text-[#C8B59A]';
  const subtitleColor = variant === 'light' ? 'text-slate-300' : 'text-slate-500';

  return (
    <div className={`flex flex-col ${s.gap} ${className}`} data-testid="haden-atlas-logo">
      <div className="flex items-baseline">
        <span 
          className={`${s.haden} font-normal tracking-wide ${hadenColor}`}
          style={{ fontFamily: "'Racing Sans One', cursive" }}
        >
          HADEN
        </span>
        <span className="w-2" /> {/* Spacer */}
        <span 
          className={`${s.atlas} font-normal ${atlasColor}`}
          style={{ fontFamily: "'Abril Fatface', serif" }}
        >
          ATLAS
        </span>
      </div>
      {showSubtitle && subtitleText && (
        <span className={`${s.subtitle} ${subtitleColor} tracking-wider uppercase`}>
          {subtitleText}
        </span>
      )}
    </div>
  );
};

export default HadenAtlasLogo;
